"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { DatePickerInput as PackageDatePickerInput } from "@salahfarzin/datetimepicker";
import { useLocalization } from "@/providers/useLocalization";
import { useTranslations } from "@/providers/TranslationsProvider";
interface DatePickerInputProps {
  id?: string;
  /** Gregorian ISO date (YYYY-MM-DD) or "" - what the API stores. */
  value: string;
  onChange: (isoDate: string) => void;
  className?: string;
  placeholder?: string;
  maxDate?: Date | string;
  minDate?: Date | string;
}

/**
 * The shared picker (@salahfarzin/datetimepicker) in the visitor's calendar
 * and format (Jalali YYYY/MM/DD for Persian, Kurdish 2726/07/26 for
 * Kurdish, DD.MM.YYYY for German, ...), with rawej's texts. The value stays
 * a Gregorian ISO date.
 */
export default function DatePickerInput(t0) {
  const $ = _c(37);
  const {
    id,
    value,
    onChange,
    className: t1,
    placeholder,
    maxDate,
    minDate
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    t
  } = useTranslations();
  const {
    config,
    language
  } = useLocalization();
  const t2 = config.calendar;
  const t3 = config.dateFormat;
  let t4;
  if ($[0] !== t) {
    t4 = t("datepicker.select date", "Select date");
    $[0] = t;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t) {
    t5 = t("datepicker.select time", "Select time");
    $[2] = t;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t) {
    t6 = t("datepicker.date", "Date");
    $[4] = t;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t) {
    t7 = t("datepicker.time", "Time");
    $[6] = t;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t) {
    t8 = t("buttons.cancel", "Cancel");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t) {
    t9 = t("datepicker.confirm", "Confirm");
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t) {
    t10 = t("buttons.cancel", "Cancel");
    $[12] = t;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t) {
    t11 = t("datepicker.open", "Open calendar");
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t12 = {
      selectDate: t4,
      selectTime: t5,
      date: t6,
      time: t7,
      cancel: t8,
      confirm: t9,
      close: t10,
      open: t11
    };
    $[16] = t10;
    $[17] = t11;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== className || $[26] !== config.calendar || $[27] !== config.dateFormat || $[28] !== id || $[29] !== language || $[30] !== maxDate || $[31] !== minDate || $[32] !== onChange || $[33] !== placeholder || $[34] !== t12 || $[35] !== value) {
    t13 = <PackageDatePickerInput id={id} value={value} onChange={onChange} className={className} placeholder={placeholder} maxDate={maxDate} minDate={minDate} calendar={t2} format={t3} language={language} labels={t12} />;
    $[25] = className;
    $[26] = config.calendar;
    $[27] = config.dateFormat;
    $[28] = id;
    $[29] = language;
    $[30] = maxDate;
    $[31] = minDate;
    $[32] = onChange;
    $[33] = placeholder;
    $[34] = t12;
    $[35] = value;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}